import { REQUEST_B_B} from '../../../const';

export default function BBReducer(state = [], action) {
  switch (action.type) {
      case REQUEST_B_B:
      return action.boja_b;
    default:
      return state;
  }
}